import { makeSelectBundlePageIdByPageIndex, RootState, setViewportPageIdForRestorePageIndexInStore } from '@/store';
import { api } from '../core';
import { refreshBundleSectionsWithCurrentFilters } from './getBundleSections';

export const SortBundleProviderType = {
  AI: 'ai',
  ORIGINAL: 'original',
} as const;

export type SortBundleProviderTypeKeys = (typeof SortBundleProviderType)[keyof typeof SortBundleProviderType];

export type SortBundleProviderResponse = {
  something: string;
};

type SortBundleProviderProps = {
  bundleId: string;
  providerId: string;
  sortType: SortBundleProviderTypeKeys;
  abortController?: AbortController;
};

const sortBundleProviderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sortBundleProvider: builder.query<SortBundleProviderResponse, SortBundleProviderProps>({
      query: ({
        bundleId,
        providerId,
        sortType,
        abortController = new AbortController(),
      }: SortBundleProviderProps) => ({
        url: `bundle/provider/sort`,
        method: 'POST',
        body: {
          bundle_id: bundleId,
          provider_section_id: providerId,
          sort_type: sortType,
        },
        signal: abortController.signal,
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          const state = getState() as RootState;

          const getBundlePageIdByPageIndex = makeSelectBundlePageIdByPageIndex(state);
          const currentPageId = getBundlePageIdByPageIndex(state.bundleViewportData.viewportPageIndexInStore);

          if (data && state.sharedData.activeBundleType) {
            dispatch(setViewportPageIdForRestorePageIndexInStore(currentPageId));
            refreshBundleSectionsWithCurrentFilters(dispatch, state);
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in sortBundleProvider in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazySortBundleProviderQuery } = sortBundleProviderApi;
